import React from "react";
import { DepartmentListScreenContextType } from "./types";

export const DepartmentListScreenContext = React.createContext<
  DepartmentListScreenContextType | undefined
>(undefined);
